import React from 'react';
import * as LC from './lazyComponents';
import { type MainLayoutProps } from '../../components';

export interface CommonProps {
  readonly withoutWrap?: boolean;
  readonly withButton?: boolean;
  readonly withoutFooter?: boolean;
  readonly wrapperProps?: MainLayoutProps;
}

export interface ConfigProps extends CommonProps {
  readonly component: LC.LazyComponentWithPreload<React.ComponentType<any>>;
  readonly images?: string[];
  readonly componentProps?: object;
}

const checkoutCommonProps = {
  images: [
    '/images/cards/card-brands/amex.png',
    '/images/cards/card-brands/discover.png',
    '/images/cards/card-brands/mastercard.png',
    '/images/cards/card-brands/visa.png',
    '/images/wallets/applePay.png',
    '/images/wallets/googlePay.png',
    '/images/wallets/paypal.png',
  ],
  wrapperProps: {
    autoHeight: true,
  },
};

export const pagesConfig: { [key: string]: ConfigProps } = {
  one_pager: {
    component: LC.Lp1Welcome,
    withoutWrap: true,
  },
  one_pager_all: {
    component: LC.ComboWelcome,
    componentProps: {
      screenId: 'one_pager_all',
      withDevices: true,
    },
    withoutWrap: true,
  },
  one_pager_all2: {
    component: LC.ComboWelcome,
    componentProps: {
      screenId: 'one_pager_all2',
      extendedBadges: true,
      withDevices: false,
    },
    withoutWrap: true,
  },
  one_pager_all3: {
    component: LC.ComboWelcome,
    componentProps: {
      screenId: 'one_pager_all3',
      extendedBadges: true,
      greenBadges: true,
      withDevices: false,
    },
    withoutWrap: true,
  },
  one_pager_all4: {
    component: LC.ComboWelcome,
    componentProps: {
      screenId: 'one_pager_all4',
      withDevices: true,
      customImg: true,
    },
    withoutWrap: true,
  },
  one_pager_all5: {
    component: LC.ComboWelcome,
    componentProps: {
      screenId: 'one_pager_all5',
      withDevices: true,
      customImg: true,
      reversed: true,
    },
    withoutWrap: true,
  },
  one_pager_all5_dc: {
    component: LC.OnePagerAll5Dc,
    componentProps: {
      screenId: 'one_pager_all5_dc',
    },
    withoutWrap: true,
  },
  one_pager_cpll: {
    component: LC.OnePagerAll5Dc,
    componentProps: {
      screenId: 'one_pager_cpll',
      titleKey: 'stay_safe_wherever_you_go',
      descriptionKey: 'simply_enter_a_phone_number',
    },
    withoutWrap: true,
  },
  one_pager_all5_kwtt: {
    component: LC.OnePagerAll5Kwtt,
    componentProps: {
      screenId: 'one_pager_all5_kwtt',
    },
    withoutWrap: true,
  },
  one_pager_all5_fr1: {
    component: LC.OnePagerAll5Fr,
    images: ['/images/welcome/welcome-combo-flight-radar.webp'],
    componentProps: {
      screenId: 'one_pager_all5_fr1',
      titleKey: 'flight_radar_track_title',
    },
    withoutWrap: true,
  },
  one_pager_all5_fr2: {
    component: LC.OnePagerAll5Fr,
    images: ['/images/welcome/welcome-combo-flight-radar.webp'],
    componentProps: {
      screenId: 'one_pager_all5_fr2',
      titleKey: 'flight_radar_follow_title',
    },
    withoutWrap: true,
  },
  one_pager_all5_fr3: {
    component: LC.OnePagerAll5Fr,
    images: ['/images/welcome/welcome-combo-flight-radar.webp'],
    componentProps: {
      screenId: 'one_pager_all5_fr3',
      titleKey: 'flight_radar_watch_title',
    },
    withoutWrap: true,
  },
  one_pager_all5_gnhdl: {
    component: LC.OnePagerAll5Gnhdl,
    componentProps: {
      screenId: 'one_pager_all5_gnhdl',
    },
    withoutWrap: true,
  },
  one_pager_all5_gnhdl_lng: {
    component: LC.OnePagerAll5Gnhdl,
    componentProps: {
      screenId: 'one_pager_all5_gnhdl_lng',
      withFlags: true,
    },
    withoutWrap: true,
  },
  one_pager_all5_ws_risk: {
    component: LC.OnePagerAllWs,
    images: ['/images/welcome/welcome-combo-woman-safety.webp'],
    componentProps: {
      screenId: 'one_pager_all5_ws_risk',
      titleKey: 'women_safety_risk_title',
    },
    withoutWrap: true,
  },
  one_pager_all5_ws_safe: {
    component: LC.OnePagerAllWs,
    images: ['/images/welcome/welcome-combo-woman-safety.webp'],
    componentProps: {
      screenId: 'one_pager_all5_ws_safe',
      titleKey: 'women_safety_safe_title',
    },
    withoutWrap: true,
  },
  one_pager_all5_ws_locate: {
    component: LC.OnePagerAllWs,
    images: ['/images/welcome/welcome-combo-woman-safety.webp'],
    componentProps: {
      screenId: 'one_pager_all5_ws_locate',
      titleKey: 'women_safety_locate_title',
    },
    withoutWrap: true,
  },
  one_pager_prnt_lg: {
    component: LC.OnePagerPrntLg,
    withoutWrap: true,
    componentProps: {
      screenId: 'one_pager_prnt_lg',
    },
  },
  one_pager_all6: {
    component: LC.ComboWelcome,
    componentProps: {
      screenId: 'one_pager_all6',
      withDevices: true,
      trustBlockVariation: 'geo',
    },
    withoutWrap: true,
  },
  one_pager_all7: {
    component: LC.ComboWelcome,
    componentProps: {
      screenId: 'one_pager_all7',
      withDevices: true,
      trustBlockVariation: 'number_one',
    },
    withoutWrap: true,
  },
  one_pager_all8: {
    component: LC.ComboWelcome,
    componentProps: {
      screenId: 'one_pager_all8',
      withDevices: true,
      trustBlockVariation: 'people',
    },
    withoutWrap: true,
  },
  one_pager_all9: {
    component: LC.ComboWelcome,
    componentProps: {
      screenId: 'one_pager_all9',
      withDevices: true,
      trustBlockVariation: 'review',
    },
    withoutWrap: true,
  },
  one_pager_all10: {
    component: LC.ComboWelcome,
    componentProps: {
      screenId: 'one_pager_all10',
      withDevices: true,
      trustBlockVariation: 'report',
    },
    withoutWrap: true,
  },
  one_pager_all11: {
    component: LC.ComboWelcome,
    componentProps: {
      screenId: 'one_pager_all11',
      withDevices: true,
      trustBlockVariation: 'rating',
    },
    withoutWrap: true,
  },
  one_pager_l1: {
    component: LC.ComboWelcome,
    componentProps: {
      screenId: 'one_pager_l1',
      howWorksUp: true,
      withDevices: true,
    },
    withoutWrap: true,
  },
  one_pager_l2: {
    component: LC.ComboWelcome,
    componentProps: {
      screenId: 'one_pager_l2',
      threeLabels: true,
      withDevices: true,
    },
    withoutWrap: true,
  },
  searching: {
    component: LC.Map,
    withoutFooter: true,
    wrapperProps: {
      customStyles: 'padding-top: 0;',
    },
  },
  searching_2: {
    component: LC.ComboMap,
    withoutFooter: true,
    wrapperProps: {
      customStyles: 'padding-top: 0;',
    },
  },
  searching_3_an: {
    component: LC.ComboMapAnimated,
    withoutFooter: true,
    wrapperProps: {
      customStyles: 'padding-top: 0;',
    },
  },
  email_consent: {
    component: LC.EmailConsent,
    images: ['/images/email-consent/icon.png'],
    componentProps: {
      screenId: 'email_consent',
    },
    withoutWrap: true,
  },
  signup: {
    component: LC.Signup,
    withButton: true,
    wrapperProps: {
      customStyles: 'justify-content: flex-start;',
    },
  },
  signup_testim: {
    component: LC.ComboSignup,
    wrapperProps: {
      customStyles: 'justify-content: flex-start; padding-top: 0;',
    },
    componentProps: {
      screenId: 'signup_testim',
    },
  },
  signup_testim_off1: {
    component: LC.ComboSignup,
    wrapperProps: {
      customStyles: 'justify-content: flex-start;',
    },
    images: ['/images/gift.png', '/images/offer.png'],
    componentProps: {
      screenId: 'signup_testim_off1',
      version: 'v1',
    },
  },
  signup_testim_off2: {
    component: LC.ComboSignup,
    wrapperProps: {
      customStyles: 'justify-content: flex-start;',
    },
    images: ['/images/gift.png', '/images/offer.png'],
    componentProps: {
      screenId: 'signup_testim_off2',
      version: 'v2',
    },
  },
  signup_testim_off3: {
    component: LC.ComboSignup,
    wrapperProps: {
      customStyles: 'justify-content: flex-start;',
    },
    componentProps: {
      screenId: 'signup_testim_off3',
      version: 'v3',
    },
  },
  signup_prnt_lg: {
    component: LC.ComboSignupPrntLg,
    withoutWrap: true,
    componentProps: {
      screenId: 'signup_prnt_lg',
    },
  },
  features: {
    component: LC.Features,
    withoutWrap: true,
    componentProps: {
      screenId: 'features',
      version: 'default',
    },
  },
  features_2: {
    component: LC.Features,
    withoutWrap: true,
    componentProps: {
      screenId: 'features_2',
      version: 'v2',
    },
  },
  checkout: {
    ...checkoutCommonProps,
    component: LC.Checkout,
  },
  checkout_v3_tr: {
    ...checkoutCommonProps,
    component: LC.ComboCheckout,
    componentProps: {
      screenId: 'checkout_v3_tr',
    },
  },
  paycheck1_pr5d_fastpay: {
    ...checkoutCommonProps,
    component: LC.ComboCheckout,
    componentProps: {
      isWalletPreselected: true,
      screenId: 'paycheck1_pr5d_fastpay',
    },
  },
  paycheck2_pr5_h_geoprice: {
    ...checkoutCommonProps,
    component: LC.ComboCheckout,
    componentProps: {
      screenId: 'paycheck2_pr5_h_geoprice',
      paywallType: 'geoprice',
      withPaypal: false,
    },
  },
  checkout_h3_pp: {
    ...checkoutCommonProps,
    component: LC.Checkout,
    componentProps: {
      customCheckout: true,
      customScreenId: 'checkout_h3_pp',
      paywall: 'lp11ch8',
    },
  },
  checkout_v3_lvl: {
    ...checkoutCommonProps,
    component: LC.Checkout,
    componentProps: {
      customCheckout: true,
      customScreenId: 'checkout_v3_lvl',
      paywall: 'lp11ch10',
    },
  },
  checkout_v3_5d_tr: {
    ...checkoutCommonProps,
    component: LC.Checkout,
    componentProps: {
      customCheckout: true,
      customScreenId: 'checkout_v3_5d_tr',
      paywall: 'lp1ch4',
    },
  },
  checkout_pr1d_fast1: {
    ...checkoutCommonProps,
    component: LC.ComboCheckout,
    componentProps: {
      screenId: 'checkout_pr1d_fast1',
      paywallType: 'combo_1day',
      isApplePayFirst: true,
    },
  },
  checkout_pr1d_fast2: {
    ...checkoutCommonProps,
    component: LC.ComboCheckout,
    componentProps: {
      screenId: 'checkout_pr1d_fast2',
      paywallType: 'combo_1day_less',
      isApplePayFirst: true,
    },
  },
  paycheck3_pr5d_h_fastpay2: {
    ...checkoutCommonProps,
    component: LC.ComboCheckout,
    componentProps: {
      screenId: 'paycheck3_pr5d_h_fastpay2',
      isApplePayFirst: true,
    },
  },
  paycheck4_pr3d_h_fastpay2: {
    ...checkoutCommonProps,
    component: LC.ComboCheckout,
    componentProps: {
      screenId: 'paycheck4_pr3d_h_fastpay2',
      paywallType: 'combo_3days',
      isApplePayFirst: true,
    },
  },
  paycheck2_pr3_h_fastpay2_bm: {
    ...checkoutCommonProps,
    component: LC.ComboCheckout,
    componentProps: {
      screenId: 'paycheck2_pr3_h_fastpay2_bm',
      paywallType: 'combo_3days',
      isApplePayFirst: true,
      withBilledMonthlyBadge: true,
    },
  },
  paycheck4_pr1w_h_fastpay2: {
    ...checkoutCommonProps,
    component: LC.ComboCheckout,
    componentProps: {
      screenId: 'paycheck4_pr1w_h_fastpay2',
      paywallType: 'combo_1week',
      isApplePayFirst: true,
      isWalletPreselected: true,
      isLegalPaywall: true,
    },
  },
  paycheck_prnt_lg: {
    ...checkoutCommonProps,
    component: LC.ComboCheckout,
    withoutWrap: true,
    componentProps: {
      screenId: 'paycheck_prnt_lg',
      paywallType: 'combo_prnt_lg',
      isApplePayFirst: true,
      isWalletPreselected: true,
      withPaypal: false,
      isPrntLayout: true,
    },
  },
  paycheck4_pr1w_h_fastpay2_cap: {
    ...checkoutCommonProps,
    component: LC.ComboCheckout,
    componentProps: {
      screenId: 'paycheck4_pr1w_h_fastpay2_cap',
      paywallType: 'combo_1week',
      isApplePayFirst: true,
      isWalletPreselected: true,
      isLegalPaywall: true,
      withCashApp: true,
      withPaypal: false,
    },
  },
  paycheck4_pr3d_h_fastpay2_ma: {
    ...checkoutCommonProps,
    component: LC.ComboCheckout,
    componentProps: {
      screenId: 'paycheck4_pr3d_h_fastpay2_ma',
      paywallType: 'combo_1week',
      isApplePayFirst: true,
      isWalletPreselected: true,
      isLegalPaywall: true,
      withAmazonPay: true,
    },
  },
  paycheck4_pr3d_h_fastpay2_ntp: {
    ...checkoutCommonProps,
    images: [...checkoutCommonProps.images, '/images/checkout/paywall-map/map-bg.webp'],
    wrapperProps: {
      ...checkoutCommonProps.wrapperProps,
      customStyles:
        '@media screen and (max-width: 991px) { padding-left: 16px; padding-right: 16px; }',
    },
    component: LC.ComboCheckout,
    componentProps: {
      screenId: 'paycheck4_pr3d_h_fastpay2_ntp',
      paywallType: 'geoprice_ntp',
      isApplePayFirst: true,
      withMapPaywall: true,
    },
  },
  paycheck4_pr3d_h_fastpay2_ntp_eu: {
    ...checkoutCommonProps,
    images: [...checkoutCommonProps.images, '/images/checkout/paywall-map/map-bg.webp'],
    wrapperProps: {
      ...checkoutCommonProps.wrapperProps,
      customStyles:
        '@media screen and (max-width: 991px) { padding-left: 16px; padding-right: 16px; }',
    },
    component: LC.ComboCheckout,
    componentProps: {
      screenId: 'paycheck4_pr3d_h_fastpay2_ntp_eu',
      paywallType: 'geoprice_ntp_eu',
      isApplePayFirst: true,
      withMapPaywall: true,
    },
  },
  paycheck4_pr3d_h_fastpay2_tp3: {
    ...checkoutCommonProps,
    component: LC.ComboCheckout,
    componentProps: {
      screenId: 'paycheck4_pr3d_h_fastpay2_tp3',
      paywallType: 'geoprice_tp3',
      isApplePayFirst: true,
    },
  },
  paycheck4_pr3d_h_fastpay2_tp3_rt: {
    ...checkoutCommonProps,
    component: LC.ComboCheckout,
    componentProps: {
      screenId: 'paycheck4_pr3d_h_fastpay2_tp3_rt',
      paywallType: 'geoprice_tp3_rt',
      isApplePayFirst: true,
    },
  },
  paycheck4_pr3d_h_fastpay2_trp4: {
    ...checkoutCommonProps,
    component: LC.ComboCheckout,
    componentProps: {
      screenId: 'paycheck4_pr3d_h_fastpay2_trp4',
      paywallType: 'geoprice_tp4',
      isApplePayFirst: true,
    },
  },
  test_pipeline_checkout: {
    ...checkoutCommonProps,
    component: LC.ComboCheckout,
    componentProps: {
      screenId: 'test_pipeline_checkout',
      paywallType: 'test_pipeline',
      isApplePayFirst: true,
    },
  },
  paycheck6_pr3d_h_lvl: {
    ...checkoutCommonProps,
    component: LC.Checkout,
    componentProps: {
      customScreenId: 'paycheck6_pr3d_h_lvl',
      paywall: 'lvl',
      isApplePayFirst: true,
      customCheckout: true,
    },
  },
  paycheck5_pr3d_h_fastpay3: {
    ...checkoutCommonProps,
    component: LC.ComboCheckout,
    componentProps: {
      screenId: 'paycheck5_pr3d_h_fastpay3',
      paywallType: 'combo_3days',
      preselectCardNonAppleDevice: true,
    },
  },
  paycheck7_pr3d_h_fastpay4: {
    ...checkoutCommonProps,
    component: LC.ComboCheckout,
    componentProps: {
      screenId: 'paycheck7_pr3d_h_fastpay4',
      paywallType: 'one_plan_3days_trial',
    },
  },
  paycheck8_pr3d_h_brp: {
    ...checkoutCommonProps,
    component: LC.ComboCheckout,
    componentProps: {
      screenId: 'paycheck8_pr3d_h_brp',
      paywallType: 'geoprice_3days_brp',
      isPixFirst: true,
      isShowPixAutomatico: true,
    },
  },
  paycheck8_pr3d_h_brp_v1: {
    ...checkoutCommonProps,
    component: LC.ComboCheckout,
    componentProps: {
      screenId: 'paycheck8_pr3d_h_brp_v1',
      paywallType: 'one_plan_geoprice_3days',
      isPixFirst: true,
      isShowPixAutomatico: true,
    },
  },
  paycheck8_pr3d_h_brp_v2: {
    ...checkoutCommonProps,
    component: LC.ComboCheckout,
    componentProps: {
      screenId: 'paycheck8_pr3d_h_brp_v2',
      paywallType: 'one_plan_geoprice_1day',
      isPixFirst: true,
      isShowPixAutomatico: true,
    },
  },
  paycheck8_pr3d_h_brp_v3: {
    ...checkoutCommonProps,
    component: LC.ComboCheckout,
    componentProps: {
      screenId: 'paycheck8_pr3d_h_brp_v3',
      paywallType: 'geoprice_3days_brp_v3',
      isPixFirst: true,
      isShowPixAutomatico: true,
    },
  },
  paycheck4_pr3d_h_upi: {
    ...checkoutCommonProps,
    component: LC.ComboCheckout,
    componentProps: {
      screenId: 'paycheck4_pr3d_h_upi',
      paywallType: 'geoprice_3days_upi',
      isApplePayFirst: true,
      isShowUpi: true,
      isUpiFirst: true,
    },
  },
  paycheck4_pr3d_h_pln: {
    ...checkoutCommonProps,
    component: LC.ComboCheckout,
    componentProps: {
      screenId: 'paycheck4_pr3d_h_pln',
      paywallType: 'geoprice_3days_pln',
      isShowBlik: true,
      isBlikFirst: true,
      isLegalPaywall: true,
    },
  },
  paycheck4_pr3d_h_fastpay2_pn: {
    ...checkoutCommonProps,
    images: [...checkoutCommonProps.images, '/images/checkout/jp-paywall/hero/map.webp'],
    component: LC.JpCheckout,
    withoutWrap: true,
    componentProps: {
      screenId: 'paycheck4_pr3d_h_fastpay2_pn',
    },
  },
  paycheck8_pr8_h_crm: {
    ...checkoutCommonProps,
    component: LC.ComboCheckout,
    componentProps: {
      screenId: 'paycheck8_pr8_h_crm',
      paywallType: 'combo_3days',
      isApplePayFirst: true,
      useAuth: true,
      isGeoPricingEnabled: true,
    },
  },
  paycheck9_pr9_h_crm: {
    ...checkoutCommonProps,
    component: LC.ComboCheckout,
    componentProps: {
      screenId: 'paycheck9_pr9_h_crm',
      paywallType: 'combo_3days_crm',
      isApplePayFirst: true,
      useAuth: true,
      isGeoPricingEnabled: true,
    },
  },
  paycheck10_pr10_h_crm: {
    ...checkoutCommonProps,
    component: LC.ComboCheckout,
    componentProps: {
      screenId: 'paycheck10_pr10_h_crm',
      paywallType: 'combo_3days_crm_less',
      isApplePayFirst: true,
      useAuth: true,
      isGeoPricingEnabled: true,
    },
  },
  paycheck10_pr3_h_tp: {
    ...checkoutCommonProps,
    component: LC.ComboCheckout,
    componentProps: {
      screenId: 'paycheck10_pr3_h_tp',
      paywallType: 'geoprice_3days',
      withPaypal: false,
    },
  },
  paycheck10_pr3_h_tp_ltm1: {
    ...checkoutCommonProps,
    component: LC.ComboCheckout,
    componentProps: {
      screenId: 'paycheck10_pr3_h_tp_ltm1',
      paywallType: 'geoprice_new',
      isApplePayFirst: true,
    },
  },
  upsell: {
    component: LC.Upsell,
    images: [],
    wrapperProps: {
      customStyles: 'justify-content: flex-start;',
    },
  },
  upsell_ar_flight: {
    component: LC.ComboUpsell,
    images: [],
    wrapperProps: {
      customStyles: 'justify-content: flex-start;',
    },
    componentProps: {
      screenId: 'upsell_ar_flight',
    },
  },
  upsell_ar_flight_tp: {
    component: LC.ComboUpsell,
    images: [],
    wrapperProps: {
      customStyles: 'justify-content: flex-start;',
    },
    componentProps: {
      screenId: 'upsell_ar_flight_tp',
      geoUpsellPreset: 'tp',
    },
  },
  upsell_ar_flight_tp_ar: {
    component: LC.ComboUpsell,
    images: [],
    wrapperProps: {
      customStyles: 'justify-content: flex-start;',
    },
    componentProps: {
      screenId: 'upsell_ar_flight_tp_ar',
      geoUpsellPreset: 'tp_ar',
    },
  },
  upsell_guide: {
    component: LC.UpsellGuide,
    images: [
      '/images/upsell-guide/safety-toolkit.png',
      '/images/upsell-guide/success-email.png',
      '/images/upsell-guide/success-bg.png',
    ],
    componentProps: {
      screenId: 'upsell_guide',
    },
  },
  upsell_guide_tp: {
    component: LC.UpsellGuide,
    images: [
      '/images/upsell-guide/safety-toolkit.png',
      '/images/upsell-guide/success-email.png',
      '/images/upsell-guide/success-bg.png',
    ],
    componentProps: {
      screenId: 'upsell_guide_tp',
      geoUpsellPreset: 'tp',
    },
  },
  upsell_guide_tp_ar: {
    component: LC.UpsellGuide,
    images: [
      '/images/upsell-guide/safety-toolkit.png',
      '/images/upsell-guide/success-email.png',
      '/images/upsell-guide/success-bg.png',
    ],
    componentProps: {
      screenId: 'upsell_guide_tp_ar',
      geoUpsellPreset: 'tp_ar',
    },
  },
  test_pipeline_upsell_subscription: {
    component: LC.ComboUpsell,
    images: [],
    wrapperProps: {
      customStyles: 'justify-content: flex-start;',
    },
    componentProps: {
      screenId: 'test_pipeline_upsell_subscription',
    },
  },
  test_pipeline_upsell_one_time: {
    component: LC.UpsellGuide,
    images: ['/images/upsell-guide/safety-toolkit.png'],
    componentProps: {
      screenId: 'test_pipeline_upsell_one_time',
    },
  },
  success: {
    component: LC.Success,
    withoutWrap: true,
    componentProps: {
      screenId: 'success',
    },
  },
  success_prnt_lg: {
    component: LC.SuccessPrntLg,
    withoutWrap: true,
    images: ['./images/success/map.webp', './images/success/map.png'],
    componentProps: {
      screenId: 'success_prnt_lg',
    },
  },
  '*': {
    component: LC.Welcome,
    withoutWrap: true,
  },
};

export interface RoutesProps extends CommonProps {
  readonly path: string;
  readonly element: React.JSX.Element;
}

export const pagesRoutes: RoutesProps[] = Object.entries(pagesConfig).map(([path, conf]) => {
  const { component: Comp, componentProps } = conf;

  return {
    ...conf,
    path: `/${path}`,
    element: <Comp {...componentProps} />,
  };
});
